import { useMutation, useQuery } from "@apollo/client/react";

import {
  DraftingFieldUpdateDocument,
  ProjectDraftingFieldsDocument,
} from "@app_schema";

import { track } from "@application/utilities/track";

// Kept the same between renders, so what reads them doesn't re-run.
const NONE: [] = [];

// His Word draft's fill-in fields on the case, and his correction to one: the
// Report is drawn again with it, so its queries (`rechecked`) and setup's
// review are asked for again. Read once (his file is parsed for them).
export const useDraftingFields = (
  projectId: string,
  enabled: boolean,
  rechecked: string[],
) => {
  const { data } = useQuery(ProjectDraftingFieldsDocument, {
    variables: { id: projectId },
    fetchPolicy: "cache-first",
    skip: !enabled,
  });
  const [mutate, state] = useMutation(DraftingFieldUpdateDocument, {
    refetchQueries: [
      ...rechecked,
      "ProjectDraftingFields",
      "ProjectDraftingSetup",
    ],
    awaitRefetchQueries: true,
  });

  // A blank `value` reads the case's again.
  const update = (kind: string, value: string) => {
    void mutate({ variables: { id: projectId, input: { kind, value } } })
      .then(() =>
        track("drafting_field_corrected", {
          project_id: projectId,
          kind,
          action: value ? "corrected" : "reset",
        }),
      )
      .catch(() => undefined);
  };

  return {
    fields: (enabled && data?.project.draftingFields) || NONE,
    update,
    error: state.error?.message,
  } as const;
};
